var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    rx: 4,
    fill: "#F92424"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 41.8161C18 39.0112 20.8119 37.0773 23.4311 38.0809L39.0689 44.0724C39.9903 44.4254 41.0097 44.4254 41.9311 44.0724L57.5689 38.0809C60.1881 37.0773 63 39.0112 63 41.8161V51C63 56.5228 58.5228 61 53 61H28C22.4772 61 18 56.5228 18 51V41.8161Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33C18 27.4772 22.4772 23 28 23H53C58.5228 23 63 27.4772 63 33C63 33.219 62.865 33.4154 62.6605 33.4939L41.9334 41.4498C41.0106 41.804 39.9894 41.804 39.0666 41.4498L18.3395 33.4939C18.135 33.4154 18 33.219 18 33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact_img.132978764da5c6b3d8cdf9e0e57b0948.svg";
export { ForwardRef as ReactComponent };